import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
        authority: "https://login.microsoftonline.com/925634d4-93b2-4447-9171-993fe5ade96d",
 */
export const msalConfig = {
    auth: {
        clientId: "a7c77e7c-4a1a-4100-bcd5-25fe4c892467",
        //clientId: "630cf912-1132-4b3d-a1f5-2ab82db3eb6a",
        authority: process.env.REACT_APP_authority,
        //authority: "https://fleetconnectid.ciamlogin.com/6fa14003-5a10-41ea-aaa4-a743a4a440d4",
        knownAuthorities: ["idgpsiau.b2clogin.com"],
        clientSecret: "HpK8Q~rFPr-wYNVi5ze-~PxPfCCHtz4frq36Lc~Q",
        //clientSecret: "km48Q~f9XC1PO674RAMJOj1GkZJ7WGMdGGVdubKJ",
        //clientSecret: "15N8Q~X7fpMKYSYVAZccG-p5d9fyXPZX82h7AcJT",
        scopes: ["openid", "offline_access", "https://idgpsiau.onmicrosoft.com/fc-api/user.default"],
        //scopes: ['openid', 'offline_access', 'api://elb.fleetconnect.com.au/630cf912-1132-4b3d-a1f5-2ab82db3eb6a/user.default'],
        navigateToLoginRequestUrl: false,
        redirectUri: process.env.REACT_APP_RedirectUri,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {	
            //logLevel: LogLevel.Verbose,
            //piiLoggingEnabled: true,
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false,
            loggerCallback: (level, message) => {	
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(`msal logger: ${message}`);		
                        return;		
                    case LogLevel.Info:		
                        console.info(`msal logger: ${message}`);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(`msal logger: ${message}`);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(`msal logger: ${message}`);		
                        return;		
                }	
            }	
        }	
    }
};
